import GeoLocation from './GeoLocation';
export default GeoLocation;
